import { z } from 'zod';

import { entityIdentifierSchema } from './chat-entity';

export const activeEntityModeSchema = z.enum(['view', 'edit']);

export type ActiveEntityMode = z.infer<typeof activeEntityModeSchema>;

export const activeEntitySchema = z.object({
    entity: entityIdentifierSchema,
    mode: activeEntityModeSchema,
});

export type ActiveEntity = z.infer<typeof activeEntitySchema>;

export const frontendContextSchema = z.object({
    activeEntities: z.array(activeEntitySchema).optional(),
});

export type FrontendContext = z.infer<typeof frontendContextSchema>;

export const newMessageRequestSchema = z.object({
    context: frontendContextSchema.optional(),
    message: z.string(),
    type: z.literal('new'),
});

export type NewMessageRequest = z.infer<typeof newMessageRequestSchema>;

export const resumeRequestSchema = z.object({
    resume: z.literal(true),
});

export type ResumeRequest = z.infer<typeof resumeRequestSchema>;

export const userMessageSchema = z.union([newMessageRequestSchema, resumeRequestSchema]);

export type UserMessage = z.infer<typeof userMessageSchema>;
